//#region Angular Imports

import { StateProvider, StateService } from '@uirouter/angularjs'

//#endregion

import { default as commonModule } from './../common/common.module'
import { default as apiModule, Api, LocalDictionaryFactory } from './../api/api.module'

import { SERVICES_MODULE_NAME } from './../../services/services.module'
import { DISTRIBUTOR_SERVICE_NAME, DistributorService } from '../../services/distributor'
import { SYSTEM_SERVICE_PROVIDER_NAME, SystemServiceProvider, $SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, SYSTEM_SERVICE_NAME, SystemService } from '../../services/system'
import { USER_SESSION_SERVICE_NAME, USER_SESSION_SERVICE_PROVIDER_NAME, UserSessionService, UserSessionServiceProvider } from '../../services/user-session'
import { ConfigHelper } from '../../helpers'

import { Enums, Activity } from '../../models/common'
import { OpOperator } from '../../models/core'

import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'

import { DistributorsController } from './distributors.controller'
import { DistributorCreateEditDirective } from './create-edit/distributor-create-edit.directive'
import { DistributorDetailsDirective } from './details/distributor-details.directive'
import { GRID_SERVICE_NAME, GridService } from '../../services/grid'

//#region Asset Imports

import * as TEMPLATE from './distributors.tpl.html'

//#endregion


// Consts

const CONTROLER_NAME: string = 'DistributorsController'
const CREATE_EDIT_DIRECTIVE_NAME: string = 'distributorCreateEdit'
const DETAILS_DIRECTIVE_NAME: string = 'distributorDetails'
const MENU_INDEX: number = 8;
const MODULE_NAME: string = 'simax.distributors'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'DISTRIBUTOR_NAME'
const STATE_NAME: string = 'distributors'
const STATE_URL: string = '/distributors'

// Consts End


// Setup

const module = angular.module(MODULE_NAME, [commonModule, apiModule, SERVICES_MODULE_NAME])

module.controller(CONTROLER_NAME, [
    $SCOPE_SERVICE_NAME,
    $STATE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    'api',
    'localDictionary',
    DISTRIBUTOR_SERVICE_NAME,
    GRID_SERVICE_NAME,
    USER_SESSION_SERVICE_NAME,
    SYSTEM_SERVICE_NAME,
    (
        $scope,
        $state: StateService,
        $timeout,
        api: Api,
        localDictionary: LocalDictionaryFactory,
        distributorService: DistributorService,
        gridService: GridService,
        userSessionService: UserSessionService,
        systemService: SystemService
    ) => new DistributorsController(
        $scope,
        $state,
        $timeout,
        api,
        localDictionary,
        distributorService,
        gridService,
        userSessionService,
        systemService,
        Enums.ReferenceType.IdDistributor,
        Enums.SimaxModuleName.Distributor
    )])

module.directive(DETAILS_DIRECTIVE_NAME, [() => new DistributorDetailsDirective()])
module.directive(CREATE_EDIT_DIRECTIVE_NAME, [() => new DistributorCreateEditDirective()])

module.config(['$stateProvider', USER_SESSION_SERVICE_PROVIDER_NAME, SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionProvider: UserSessionServiceProvider,
    systemServiceProvider: SystemServiceProvider
) => {

    systemServiceProvider.registerDetailsComponent({
        key: 'Distributor_IdDistributor',
        componentName: DETAILS_DIRECTIVE_NAME
    })

    userSessionProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.DISTRIBUTOR_LIST)
                && !loggedOperator.hasPermission(Activity.DISTRIBUTOR_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DistributorModule)) {

                MenuItem.addMenuItem(ConfigHelper.getIconName(
                    ConfigHelper.Icon.DISTRIBUTORS),
                    'distributors',
                    MODULE_NAME_LOCALIZATION_TEXT,
                    STATE_NAME,
                    MENU_INDEX)

                $stateProvider.state(STATE_NAME, {
                    url: STATE_URL,
                    controller: CONTROLER_NAME,
                    controllerAs: '$ctrl',
                    template: TEMPLATE,
                    params: { ids: null }
                })
            }
        })
}])

// Setup End

export default MODULE_NAME
